import React from 'react'
import CONSTANTS from 'utils/constants'

const CernerHIE = ({ residentId }: { residentId: string }) => {
  return (
    <iframe
      title="HIC"
      src={`${CONSTANTS.VITE_APP_CM_API}/services/cerner/${residentId}?init=true`}
      width="100%"
      height="100%"
      style={{ border: 'none', minWidth: '1024px', minHeight: '768px' }}
      data-testid="cerner-hie"
    />
  )
}

export default CernerHIE
